import { COLLECTION_IDS } from "../../../../config/collections.js";
import "../../../../lib/store/createAppApi.js";
import "../../../../lib/store/createAppAsyncThunk.js";
import { createAppSelector } from "../../../../lib/store/createAppSelector.js";
import "../../../../lib/store/createAppSlice.js";
import "react";
import "redux";
import "../../../../lib/store/hooks/useAppDispatch.js";
import "../../../../lib/store/hooks/useAppSelector.js";
import "../../../../lib/store/hooks/useAppStore.js";
import { selectSlice } from "./selectSlice.js";
const locationMarkerKeysMap = {
  dealer: "dealer",
  dealership: "dealership",
  country: "country",
  city: "city"
};
const selectLocationCollectionIds = createAppSelector(selectSlice, (config) => {
  const locationMarkerKey = Array.isArray(config.locationMarker) ? config.locationMarker.map((locationMarker) => locationMarkerKeysMap[locationMarker]) : locationMarkerKeysMap[config.locationMarker];
  const locationTypes = Array.isArray(locationMarkerKey) ? locationMarkerKey : [locationMarkerKey];
  const locationCollectionIds = [];
  locationTypes.forEach((locationType) => {
    switch (locationType) {
      case "country":
        locationCollectionIds.push(COLLECTION_IDS.dealersCountries);
        break;
      case "city":
        locationCollectionIds.push(COLLECTION_IDS.dealersCities);
        break;
      case "dealer":
        locationCollectionIds.push(COLLECTION_IDS.dealersDealers);
        break;
      case "dealership":
        locationCollectionIds.push(COLLECTION_IDS.dealersDealership);
        break;
    }
  });
  return locationCollectionIds;
});
export {
  selectLocationCollectionIds
};
